export const WEBCLOCK_FAIL_CLOSED_MESSAGE =
  'Unable to start WebClock. Please close and reopen the time clock.';

let webClockReactRoot = null;

/**
 * Registers the React root created by the WebClock entrypoint so fail-closed
 * can unmount it before replacing the DOM (avoids React re-committing over
 * the locked message).
 *
 * @param {import('react-dom/client').Root | null} root
 */
export const setWebClockReactRoot = (root) => {
  webClockReactRoot = root;
};

/**
 * Replaces the WebClock root with a locked fail-closed message.
 * Used for bootstrap aborts and unconfirmed offline secure-storage cleanup.
 *
 * @param {unknown} [error]
 * @param {string} [logLabel]
 */
export const renderWebClockFailClosed = (
  error,
  logLabel = '[WebClock] Bootstrap failed:'
) => {
  if (error !== undefined) {
    console.error(logLabel, error);
  }

  if (webClockReactRoot) {
    try {
      webClockReactRoot.unmount();
    } catch {
      // Root may already be unmounted; still clear DOM below.
    }
    webClockReactRoot = null;
  }

  const root = document.getElementById('component-root');

  if (!root) {
    return;
  }

  root.textContent = WEBCLOCK_FAIL_CLOSED_MESSAGE;
};
